<template>
  <div>
    <loading
      :active.sync="loading.content"
      :can-cancel="false"
      :is-full-page="true"
      :color="'#0B8BCC'"
      :loader="'dots'"
      :opacity="0.7"
      :lock-scroll="true"
    ></loading>
    <div class="appHeader bg-primary text-light shadow-header-footer">
      <div class="left">
        <a href="Javascript:;" class="headerButton" @click="$router.go(-1)">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </a>
      </div>
      <div class="pageTitle">F.A.Q</div>
    </div>
    <div id="appCapsule" v-if="!loading.content">
      <div class="section inset mt-2">
        <div class="accordion" id="faq">
          <div class="item">
            <div class="accordion-header">
              <button
                class="btn collapsed"
                type="button"
                data-toggle="collapse"
                :data-target="'#FAQ0'"
              >
                <b>Pendahuluan</b>
              </button>
            </div>
            <div
              :id="'FAQ0'"
              class="accordion-body collapse"
              data-parent="#faq"
            >
              <div class="accordion-content">
                <p>
                  FAQ (Frequently Asked Questions) adalah kumpulan beberapa
                  pertanyaan yang sering di ajukan pengguna kepada kami, untuk
                  memudahkan pengguna dalam mendapatkan informasi semua
                  pertanyaan yang sering di tanyakan pada layanan pengguna akan
                  di tampilkan di halaman ini.
                </p>
              </div>
            </div>
          </div>
          <div class="item" v-for="(item, index) in faq" :key="index">
            <div class="accordion-header">
              <button
                class="btn collapsed text-left"
                type="button"
                data-toggle="collapse"
                :data-target="'#FAQ' + item.id"
              >
                <b>{{ item.question }}</b>
              </button>
            </div>
            <div
              :id="'FAQ' + item.id"
              class="accordion-body collapse"
              data-parent="#faq"
            >
              <div class="accordion-content" v-html="item.answer"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import $axios from "./../../api.js";
export default {
  data() {
    return {
      loading: {
        content: true,
      },
      faq: [],
    };
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapState(["setting"]),
  },
  methods: {
    getData() {
      $axios.get("/faq").then((response) => {
        this.faq = response.data.data;
        this.loading.content = false;
      });
    },
  },
};
</script>
